<template>
  <div id="app">
    <Nav></Nav>
    <div class="toptit"></div>
    <div class="block">
      <h1>
        <span>策略</span>&创意
      </h1>
    </div>
    <div class="strategy">
      <div class="left-hover">
        <img src="../assets/strategy-left.png" alt />
        <div class="left-zhezhao" @click="openLeft">
          <img src="../assets/celue-hover.png" alt />
          <p>营销策划</p>
        </div>
      </div>
      <div class="right-hover">
        <img src="../assets/strategy-right.png" alt />
        <div class="right-zhezhao" @click="openRight">
          <img src="../assets/celue-hover.png" alt />
          <p>产品创意</p>
        </div>
      </div>
    </div>
    <BottomNav></BottomNav>
    <div class="popupBody" :style="display"></div>
    <div class="swiper-container" :style="swiperDisplay">
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <div class="popup" :style="firstDisplay">
            <div class="popup-tit">
              <span>营销策划</span>
              <div @click="closeAll()">×</div>
            </div>
            <div class="popupFather">
              <div class="text-content">
                <h1>为品牌提供IP运用，资源匹配，权益管理以及IP产品开发等营销策划服务：</h1>
                <p>
                  <span></span>精准判断品牌与IP的营销结合点，有机整合双方需求及优势
                </p>
                <p>
                  <span></span>配合IP推广造势，打造沉浸式主题传播活动，深度影响消费者心智，提升品牌好感度
                </p>
              </div>
              <div class="strategy-img">
                <div class="strategy-img-left">
                  <div>
                    <img src="../assets/strategy-loin.png" class="loin" alt />
                  </div>
                  <div>
                    <img src="../assets/strategy-man.png" class="strategy-man" alt />
                    <div>
                      <p>结合品牌调性、IP形象及节日，打造爆点话题融合产品制作主题场景</p>
                    </div>
                  </div>
                </div>
                <div class="strategy-img-middle">
                  <div>
                    <p>以“天生为王”为主题</p>
                    <p>视觉设计+主题堆头+路演</p>
                    <p>+狮子王系列定制产品</p>
                    <p>打造沉浸式营销推广</p>
                  </div>
                  <img src="../assets/brand-second-2-new.png" alt />
                </div>
                <div class="strategy-img-right">
                  <img src="../assets/strategy-bigloin.png" alt />
                </div>
              </div>
              <div class="bg-left">
                <img src="../assets/strategy-bg-left.png" alt />
              </div>
              <div class="bg-top">
                <img src="../assets/strategy-bg-top.png" alt />
              </div>
              <div class="bg-right">
                <img src="../assets/strategy-bg-right.png" alt />
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="Pro-popup" :style="secondDisplay">
            <div class="Pro-popup-tit">
              <span>产品创意</span>
              <div @click="closeAll()">×</div>
            </div>
            <div class="Pro-popupFather">
              <div class="Pro-text-content">
                <h1>结合消费者需求，量身定做主题活动及套系产品:</h1>
                <p>
                  <span></span>打通线上线下，营造完整IP主题场景体验
                </p>
                <p>
                  <span></span>借势IP资源推广， 结合IP元素及场景推出主题玩具、主题餐厅及活动等
                </p>
                <p>
                  <span></span>搭载有趣创意，新奇品牌体验
                </p>
              </div>
              <div class="Pro-strategy-img">
                <div class="Pro-strategy-img-top">
                  <div>
                    <img src="../assets/product-top-1.png" class="img-top-1" alt />
                    <img src="../assets/product-top-2.png" class="img-top-2" alt />
                    <img src="../assets/product-top-3.png" class="img-top-3" alt />
                    <img src="../assets/product-top-4.png" class="img-top-4" alt />
                  </div>
                  <img src="../assets/product-top-5.png" class="img-top-5" alt />
                  <img src="../assets/product-top-6.png" class="img-top-6" alt />
                </div>
                <div class="Pro-strategy-img-bottom">
                  <img src="../assets/product-bottom-1-new.png" class="img-bottom-1" alt />
                  <img src="../assets/product-bottom-2.png" class="img-bottom-2" alt />
                  <img src="../assets/chanpin-4-1.png" class="img-bottom-3" alt />
                  <img src="../assets/chanpin-3-1.png" class="img-bottom-4" alt />
                </div>
              </div>
              <div class="Pro-bg-left">
                <img src="../assets/strategy-bg-left.png" alt />
              </div>
              <div class="Pro-bg-top">
                <img src="../assets/strategy-bg-top.png" alt />
              </div>
              <div class="Pro-bg-right">
                <img src="../assets/strategy-big-right.png" alt />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Add Arrows -->
      <div class="swiper-button-next"></div>
      <div class="swiper-button-prev"></div>
    </div>
    <div class="swiper-pagination" :style="pointDisplay"></div>
    <div class="celue-bg">
      <img src="../assets/celue-bg.png" alt />
    </div>
  </div>
</template>

<script>
import Nav from "../components/Nav";
import BottomNav from "../components/BottomNav";
import Vue from "vue";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import Swiper from "swiper";
import $ from "jquery";
export default {
  name: "Strategy",
  data() {
    return {
      display: [{ display: "none" }],
      firstDisplay: [{ display: "block" }],
      secondDisplay: [{ display: "block" }],
      swiperDisplay: [{ display: "none" }],
      pointDisplay: [{ display: "none" }]
    };
  },
  methods: {
    closeAll() {
      this.display = { display: "none" };
      this.swiperDisplay = [{ display: "none" }];
      this.firstDisplay = [{ display: "none" }];
      this.secondDisplay = [{ display: "none" }];
      this.pointDisplay = [{ display: "none" }];
    },
    openLeft() {
      this.display = { display: "block" };
      this.swiperDisplay = [{ display: "block" }];
      this.firstDisplay = [{ display: "block" }];
      this.secondDisplay = [{ display: "block" }];
      this.pointDisplay = [{ display: "block" }];
    },
    openRight() {
      this.display = { display: "block" };
      this.swiperDisplay = [{ display: "block" }];
      this.firstDisplay = [{ display: "block" }];
      this.secondDisplay = [{ display: "block" }];
      this.pointDisplay = [{ display: "block" }];
    }
  },
  mounted() {
    var swiper = new Swiper(".swiper-container", {
      observer: true,
      observerParents: true,
      // 如果需要分页器
      pagination: {
        el: '.swiper-pagination',
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      }
    });
    $('.left-zhezhao').click(function(){
      swiper.slideTo(0)
    })
    $('.right-zhezhao').click(function(){
      swiper.slideTo(1)
    })
    window.onscroll = function() {
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      var topNav = document.getElementById("topNav");
      if (scrollTop > 0) {
        topNav.style.width = "100%";
        topNav.style.position = "fixed";
        topNav.style.top = "0";
        topNav.style.left = "0";
        topNav.style.paddingLeft = "33.5%";
        // topNav.style.zIndex = 11;
      } else {
        // topNav.style.paddingLeft = "0%";
        // topNav.style.width = "32.42%";
        // topNav.style.left = "33.5%";
        // topNav.style.zIndex = 9;
      }
      // if (scrollTop = 0) {
      //   topNav.style.width = "29.42%";
      // }
    };
    
  },
  components: { Nav, BottomNav }
};
</script>

<style lang="less" scoped>
#app {
  font-family: "微软雅黑";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  position: relative;
  @media screen and (min-width: 140px) {
    min-width: 1050px;
    margin: 0 auto;
  }
  @media screen and (min-width: 1920px) {
    min-width: 1240px;
    margin: 0 auto;
  }
}
.image {
  width: 100%;
}
.logoImg {
  width: 141px;
  height: 86px;
}
.celue-bg {
  position: absolute;
  width: 90%;
  margin: 0 auto;
  top: 355px;
  z-index: -11;
  img {
    width: 100%;
  }
}
.tit {
  text-align: left;
  h1 {
    color: #fce04f;
    font-size: 61px;
    font-family: Impact;
    font-weight: 400;
    border-bottom: 2px solid #fce04f;
    width: 67px;
  }
  p {
    font-size: 20px;
  }
}
.block {
  background-color: #333333;
  height: 100px;
  display: flex;
  align-items: center;
  h1 {
    color: #ffffff;
    line-height: 100px;
    width: fit-content;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    margin: 0 0 0 35%;
    @media screen and (min-width: 140px) {
        font-size: 24px;
      }
    @media screen and (min-width: 1920px) {
      font-size: 26px;
    }
    span {
      border-bottom: 4px solid #fce04f;
      padding-bottom: 5px;
    }
  }
}
.toptit {
  width: 100%;
  height: 56px;
}
.strategy {
  padding: 100px 0;
  margin: 0 auto;
  width: 65%;
  display: flex;
  justify-content: space-between;
  & > div {
    position: relative;
    width: 50%;
    div {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 99%;
      background: rgba(0, 0, 0, 0.6);
      opacity: 0;
      p {
        font-size: 32px;
        font-weight: bold;
        color: #fce04f;
        margin: 0;
        margin-top: 37%;
      }
      img {
        position: absolute;
        top: 50%;
        margin-top: -55px;
        left: 50%;
        margin-left: -20px;
      }
      // opacity: 0;
    }
    & > img {
      width: 100%;
    }
  }
  .left-hover:hover .left-zhezhao {
    opacity: 1;
    cursor: pointer;
  }
  .right-hover:hover .right-zhezhao {
    opacity: 1;
    cursor: pointer;
  }
}
.popupBody {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background-color: #000;
  opacity: 0.8;
  z-index: 1000;
}
.popup {
  position: absolute;
  top: 0px;
  width: 1240px;
  z-index: 10000;
  .popup-tit {
    padding: 0 96px;
    height: 62px;
    background: #000;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.2);
    display: flex;
    justify-content: space-between;
    span {
      line-height: 62px;
      font-size: 30px;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
    }
    div {
      width: 31px;
      height: 31px;
      border-radius: 50%;
      background-color: #fce04f;
      border: none;
      line-height: 27px;
      margin-top: 15px;
      font-size: 31px;
      text-align: center;
    }
    div:hover {
      cursor: pointer;
    }
  }
  .popupFather {
    background-color: #ffffff;
    padding: 0 96px 20px 96px;
    position: relative;
    .text-content {
      h1 {
        font-size: 16px;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        text-align: left;
        padding-top: 10px;
        margin: 0;
      }
      p {
        font-size: 16px;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        text-align: left;
        span {
          width: 10px;
          height: 10px;
          background: rgba(252, 224, 79, 1);
          border-radius: 50%;
          display: inline-block;
          margin-right: 5px;
        }
      }
    }
    .strategy-img {
      display: flex;
      justify-content: space-between;
      position: relative;
      z-index: 2;
      .strategy-img-left {
        width: 266px;
        .loin {
          width: 266px;
          height: 194px;
        }
        & > div {
          display: flex;
          margin-top: 13px;
          justify-content: space-between;
          width: 100%;
          .strategy-man {
            width: 125px;
            height: 173px;
          }
          & > div {
            padding: 0 21px;
            background-color: #fce04f;
            width: 88px;
            height: 173px;
            p {
              padding-top: 10px;
              margin: 0;
              text-align: left;
              font-size: 16px;
              color: rgba(51, 51, 51, 1);
              line-height: 25px;
              @media screen and (min-width: 140px) {
                font-size: 14px;
              }
              @media screen and (min-width: 1920px) {
                font-size: 16px;
              }
            }
          }
        }
      }
      .strategy-img-middle {
        width: 246px;
        div {
          width: 100%;
          height: 146px;
          background-color: #fce04f;
          margin-top: 13px;
          padding-top: 46px;
          color: #333;
          p {
            margin: 0;
            line-height: 25px;
            @media screen and (min-width: 140px) {
              font-size: 14px;
            }
            @media screen and (min-width: 1920px) {
              font-size: 16px;
            }
          }
        }
        img {
          width: 100%;
          height: 173px;
          margin-top: 13px;
        }
      }
      .strategy-img-right {
        width: 511px;
        img {
          width: 100%;
          height: 381px;
          margin-top: 13px;
        }
      }
    }
  }
  .bg-left {
    position: absolute;
    bottom: 30px;
    left: 0;
  }
  .bg-top {
    position: absolute;
    right: 126px;
    top: 0;
  }
  .bg-right {
    position: absolute;
    bottom: 10px;
    right: 0;
  }
}
.Pro-popup {
  position: absolute;
  top: 0px;
  width: 1240px;
  z-index: 10000;
  .Pro-popup-tit {
    padding: 0 96px;
    height: 62px;
    background: #000;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.2);
    display: flex;
    justify-content: space-between;
    span {
      line-height: 62px;
      font-size: 30px;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
    }
    div {
      width: 31px;
      height: 31px;
      border-radius: 50%;
      background-color: #fce04f;
      border: none;
      margin-top: 15px;
      font-size: 30px;
      text-align: center;
      line-height: 27px;
    }
    div:hover {
      cursor: pointer;
    }
  }
  .Pro-popupFather {
    background-color: #ffffff;
    padding: 0 96px 20px 96px;
    position: relative;
    .Pro-text-content {
      h1 {
        font-size: 16px;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        text-align: left;
        padding-top: 10px;
        margin: 0;
      }
      p {
        font-size: 16px;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        text-align: left;
        span {
          width: 10px;
          height: 10px;
          background: rgba(252, 224, 79, 1);
          border-radius: 50%;
          display: inline-block;
          margin-right: 5px;
        }
      }
    }
    .Pro-strategy-img {
      position: relative;
      z-index: 2;
      .Pro-strategy-img-top {
        display: flex;
        justify-content: space-between;
        position: relative;
        div {
          margin-right: 11px;
        }
        .img-top-1 {
          width: 96px;
          height: 209px;
        }
        .img-top-2 {
          width: 113px;
          height: 209px;
          margin-left: -5px;
        }
        .img-top-3 {
          width: 86px;
          height: 209px;
          margin-left: -5px;
        }
        .img-top-4 {
          width: 94px;
          height: 209px;
          margin-left: -5px;
        }
        .img-top-5 {
          width: 298px;
          height: 209px;
          margin-left: -5px;
        }
        .img-top-6 {
          width: 340px;
          height: 209px;
        }
      }
      .Pro-strategy-img-bottom {
        display: flex;
        justify-content: space-between;
        margin-top: 7px;
        .img-bottom-1 {
          width: 200px;
          height: 133px;
        }
        .img-bottom-2 {
          width: 222px;
          height: 133px;
        }
        .img-bottom-3 {
          width: 248px;
          height: 133px;
        }
        .img-bottom-4 {
          width: 281px;
          height: 133px;
        }
      }
    }
  }
  .Pro-bg-left {
    position: absolute;
    bottom: 30px;
    left: 0;
  }
  .Pro-bg-top {
    position: absolute;
    right: 126px;
    top: 0;
  }
  .Pro-bg-right {
    position: absolute;
    bottom: 10px;
    right: 0;
  }
}
.swiper-container {
  width: 1240px;
  height: 589px;
  position: fixed;
  top: 50%;
  margin-top: -300px;
  left: 50%;
  margin-left: -620px;
  z-index: 10000;
}
.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;

  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}
.swiper-button-prev:after,
.swiper-button-next:after {
  font-size: 30px;
}
.swiper-button-next:after {
  margin-left: 5px;
  color: #fff;
}
.swiper-button-prev:after {
  margin-right: 5px;
  color: #fff;
}
.swiper-button-next {
  width: 50px;
  height: 50px;
  background-color: rgba(31, 45, 61, 0.11);
  border-radius: 50%;
  text-align: center;
  color: #fff;
}
.swiper-button-prev {
  width: 50px;
  height: 50px;
  background-color: rgba(31, 45, 61, 0.11);
  border-radius: 50%;
  text-align: center;
  color: #fff;
}
.swiper-pagination{
  position: fixed;
  top: 790px;
  left: 49%;
  z-index: 10000;
  display: flex !important;
  justify-content: space-around;
  width: 30px;
  .swiper-pagination-bullet-active{
    color: #ccc;
  }
  &>span{
    margin-right: 50px;
  }
}
.swiper-pagination-bullet{
  margin-right: 10px!important;
}
</style>
<style lang="less">
// .el-submenu__title:hover{
//   background-color: #fff !important;
// }
:root {
  --swiper-theme-color: rgb(215,217,222) !important;
}
.el-submenu__title {
  color: #333 !important;
}
.el-submenu__title a {
  color: #333 !important;
}
// .el-carousel__container {
//   height: 500px;
// }
</style>
